import { notificationController } from '@app/controllers/notificationController';
import { doRequestOTP } from '@app/store/slices/authSlice';
import { AppDispatch } from '@app/store/store';
import { TFunction } from 'react-i18next';
import { NavigateFunction } from 'react-router-dom';
import { cryptoEncrpytHandler } from './rememberMeController';

export interface IOtpValue {
  email: string;
  rememberMe?: boolean;
}

export const getLoginErrorMessage = (t: TFunction<'translation', undefined>, error: string): string => {
  switch (error) {
    case 'User is not verified':
      return t('auth.userNotVerified');
    case 'User is not approved':
      return t('auth.userNotApproved');
    default:
      return error;
  }
};

export const SendOtpHandler = (
  values: IOtpValue,
  dispatch: AppDispatch,
  navigate: NavigateFunction,
  t: TFunction<'translation', undefined>,
  setLoadingEnable: () => void,
  setLoadingDisable: () => void,
): void => {
  const payload = {
    email: values.email,
  };
  setLoadingEnable();

  dispatch(doRequestOTP(payload))
    .unwrap()
    .then(() => {
      notificationController.info({ message: t('common.successRequestOTP') });
      setLoadingDisable();
      navigate('/auth/security-code', { state: { email: payload.email, rememberMe: values.rememberMe } });
      cryptoEncrpytHandler({ email: values.email, rememberMe: values.rememberMe });
    })
    .catch((err: { message: string; code: number }) => {
      notificationController.error({ message: getLoginErrorMessage(t, err.message) });
      setLoadingDisable();
    });
};
